import DraftListingProvider from './DraftListing.provider';

export default DraftListingProvider;